import { Copy } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

/** "Reference code: req_… [copy]" — what the owner/support needs to find the log line. */
export function CopyReferenceButton({ requestId }: { requestId: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  return (
    <span className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
      <span data-slot="request-id">{t("errors.reference", { id: requestId })}</span>
      <button
        type="button"
        className="inline-flex min-h-8 items-center gap-1 rounded border px-2 font-medium text-foreground hover:bg-accent"
        onClick={() => {
          void navigator.clipboard?.writeText(requestId).then(
            () => {
              setCopied(true);
            },
            () => undefined,
          );
        }}
      >
        <Copy className="size-3.5" aria-hidden />
        {copied ? t("errors.copied") : t("errors.copy_reference")}
      </button>
    </span>
  );
}
